function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  className: "education_svg__cls-1",
  d: "M93.09 34.16L66.27 19.14 39.45 34.16 12.62 49.18l17.62 9.87 5 2.8 4.21 2.36 26.82 15.02 26.82-15.02 2.96-1.66 5-2.8 18.86-10.56-26.82-15.03zm7.96 19.86l-5 2.81-5.4 3.02L66.27 73.5 41.89 59.85l-6.65-3.73-5-2.8-7.38-4.13 7.38-4.13 11.65-6.53 24.38-13.66 24.38 13.66 10.4 5.83 8.63 4.83-8.63 4.83z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "education_svg__cls-1",
  d: "M65.65 21.78L30.24 42.22v2.84l11.65-6.53 24.38-13.66 24.38 13.66 10.4 5.83v-2.14l-35.4-20.44zm30.4 58.44l-30.4 17.56-30.41-17.56v-24.1l-5-2.8v29.79l35.41 20.44 35.4-20.44v-7.27h-5v4.38zm0-23.39v13.18h5V54.02l-5 2.81z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "education_svg__cls-1",
  d: "M96.05 70.01h5v5.83h-5zM109.14 49.78h5v38.96h-5z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "education_svg__cls-1",
  d: "M118.28 102.53h-13.46v-11.7c0-3.71 3.02-6.73 6.73-6.73s6.73 3.02 6.73 6.73v11.7zm-8.46-5h3.46v-6.7c0-.96-.78-1.73-1.73-1.73s-1.73.78-1.73 1.73v6.7z"
});

function SvgEducation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 132.54 132.54",
    className: "w-full h-full fill-current"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default SvgEducation;